import { render, staticRenderFns } from "./ccr.vue?vue&type=template&id=1f82ca6c"
import script from "./ccr.vue?vue&type=script&lang=js"
export * from "./ccr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports